module.exports = __webpack_public_path__ + "img/class.463c2a77.svg";